import { Box, Typography, TextField, Button } from "@mui/material";
import { useState } from "react";
import sendMail from '../../assets/send-mail.png';

export default function ForgotPwd({close}) {
    const [mail, setMail] = useState('');
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');
    const [isError, setIsError] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setMsg(''); setIsError(false);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/users/mail/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ mail })
            });

            if (!response.ok) {
                const errorText = await response.text();
                setMsg(errorText || 'Erreur lors de l\'envoi de l\'e-mail.');
                setIsError(true);
            } else {
                setMsg('Un e-mail de réinitialisation a été envoyé à votre adresse.');
                setIsError(false);
            }
        } catch (error) {
            console.error('Erreur lors de la réinitialisation du mot de passe :', error);
            setMsg('Une erreur est survenue. Veuillez réessayer plus tard.');
            setIsError(true);
        } finally {
            setLoading(false);
        }
    }

     return (
        (!loading && !!msg && !isError) ?
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, pt:10 }}>
            <img src={sendMail} alt="Send Mail" style={{ width: '120px', height: '120px', mt: 4}} />
            <Typography variant="body1" align="center" sx={{ mt: 2, mb:7, fontSize:24, fontWeight:500, fontStyle:'italic', color: 'primary.main' }}>
                {msg}
            </Typography>
            <Button variant="contained" color="primary" onClick={close} sx={{ mb: 2, alignSelf:'end' }}>
                Ok
            </Button>
        </Box>
        :
        <Box component='form' onSubmit={handleSubmit} sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button variant="text" color="primary" onClick={close} sx={{ alignSelf: 'end', mt: -2 }}>Fermer</Button>

            <Typography variant="h6" align="center" sx={{ mt: 2 }}>Vous avez oublié votre mot de passe ?</Typography>
            {(msg && isError) ? 
            <Typography variant="body1" color="error" align="center" sx={{ mt: 2 }}>{msg}</Typography>
            :
            <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                Si vous avez oublié votre mot de passe, entrez votre adresse e-mail. Nous vous enverrons un e-mail pour réinitialiser votre mot de passe.
            </Typography>}

            <TextField fullWidth label="Adresse e-mail" variant="outlined" required
            onBlur={() => setMail(mail.trim())}
            onChange={(e) => setMail(e.target.value)} />
            <Typography variant="body1" align="center" sx={{ mt: 2, color: 'focus.main', fontWeight:'bold', fontSize: 14 }}>
                Le lien de réinitialisation du mot de passe sera envoyé à l'adresse e-mail fournie si elle est associée à un compte. Ce lien ne sera clickable qu'une seule fois et expirera après 24 heures.
            </Typography>

            <Button variant="contained" type='submit' color="primary" disabled={!!!mail || loading} sx={{ mt: 2, alignSelf: 'center' }}>{loading ? 'Envoi...' : 'Envoyer l\'e-mail'}</Button>
        </Box>
     )
}